





















import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class LoadErrorCard extends Vue {
    @Prop({required: true}) title!: string;
    @Prop({required: true}) message!: string;
    @Prop({required: true}) retryLabel!: string;
    @Prop({required: true}) accentColor!: string;
    @Prop({default: false}) retrying!: boolean;
}
